import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProjectConfig } from "Global";
import TopBar from "elements/TopBar/TopBar";
import Toolbar from "elements/Toolbar/Toolbar";
import BasicAccordionSub from "elements/BasicAccordionSub";
import BasicAccordionPdf from "elements/BasicAccordionPdf";

export default function RitualesViewer(props: any) {
  /*=======================================
    GET RITUAL ID FROM URL
  =======================================*/
  let { ritual_id } = useParams();
  /*=======================================
  =======================================*/

  const lang_id = localStorage.getItem('lang_id') || '1';

  const defaultValues: any = {
    ritual_id: ritual_id ? ritual_id : "null",
    image: "",
    title: "",
    date: null,
    contentHTML: "",
    contentJSON: null,
  };

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(defaultValues);

  const [categoriasAll, setCategoriasAll] = useState<Categoria[]>([]);

  interface SubCategoria {
    id: number;
    padre_id: number;
    label: string;
    titulo: string;
    contentJSON: any | null;
    contentJSON_send: any | null;
    contentHTML: string;
    contentHTML_send: string;
    estado: string;
    delete: number;
  }

  interface Categoria {
    id: number;
    label: string;
    titulo: string;
    contentJSON: any | null;
    contentJSON_send: any | null;
    contentHTML: string;
    contentHTML_send: string;
    subCategorias: SubCategoria[];
    estado: string;
    delete: number;
  }

  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/

  interface pdfData {
    file_id: any;
    file: any;
    name: string;
    estado: string;
  }

  const [filesPdf, setFilesPdf] = useState<pdfData[]>([]);

  useEffect(() => {
    props.setLoading(true);
    if (ritual_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "rituales_details",
            id: ritual_id,
            lang_id: lang_id,
          },
        })
        .then((response) => {
          setValues(response.data);
          props.setLoading(false);
          response.data.categorias.map(
            (categoriaNew: Categoria, index1: number) =>
              setCategoriasAll((prevCategorias) => {
                const newCategorias = [...prevCategorias];
                newCategorias[index1] = categoriaNew;
                return newCategorias;
              })
          );

          setFilesPdf(response.data.files);
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);
  /*=======================================
  =======================================*/

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    function handleDeviceChange(e: any) {
      setIsMobile(e.matches);
    }

    mediaQuery.addEventListener("change", handleDeviceChange);
    handleDeviceChange(mediaQuery);

    return () => {
      mediaQuery.removeEventListener("change", handleDeviceChange);
    };
  }, []);

  // El título y contenido ya vienen en el idioma correcto desde la tabla rituales

  return (
    <div id="RitualesView" className="module_container">
      <div className="module_topBar">
        <TopBar title="Ritos" />
        <Toolbar />
      </div>

      <div className="module_content">
        {values.image && (
          <div id="mv_image">
            <img src={values.image} />
          </div>
        )}
        <h2>{values.title}</h2>

        <div id="HTMLContent">
          <div dangerouslySetInnerHTML={{ __html: values.contentHTML }} />
        </div>
      </div>

      {categoriasAll.map((categoria, index) => (
        <div key={index}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <BasicAccordionSub
              titulo={categoria.titulo}
              contenido={categoria.contentHTML}
              subCategorias={categoria.subCategorias}
            />
          </div>
        </div>
      ))}

      {filesPdf.map((file, index) => (
        <div key={index}>
          <BasicAccordionPdf
            titulo={file.name}
            filePdf={file.file}
          ></BasicAccordionPdf>
        </div>
      ))}
    </div>
  );
}
